import clsx from 'clsx';
import { ID_DANG_KY_KHAM, UU_TIEN } from '../../utils/Constant';
import { formatDateToDDMMYYYY, parseJSON } from '../../utils/FormatUtils';

type Props = {
	data: {
		patientCode: string;
		patientName: string;
		visitTypeId: number;
		display: {
			style: string;
			text: string;
		} | null;
		visitSortWeight: number;
		visitObjectTypeName: string;
		gender: string;
		fulfillDeptName?: string;
		startDate?: string;
	};
};

const PatientRowData = ({ data }: Props) => {
	let display = parseJSON(data?.display);

	return (
		<div className="text-system text-truncate" title={data?.fulfillDeptName || ''}>
			<div className="flex m-0">
				<span
					className={clsx('text-uppercase', {
						'color-error': data?.visitTypeId === ID_DANG_KY_KHAM.CAP_CUU,
					})}
				>
					{data?.patientName}
				</span>

				<span
					hidden={!data?.startDate}
					className={clsx('text-uppercase', {
						'color-error': data?.visitTypeId === ID_DANG_KY_KHAM.CAP_CUU,
					})}
				>
					&nbsp;
					{`(${formatDateToDDMMYYYY(data?.startDate)})`}
				</span>

				{display?.text && (
					<span style={display?.style}>
						&nbsp;{display?.text ? `(${display?.text})` : ''}
					</span>
				)}

				{data?.visitSortWeight === UU_TIEN.TRUE && (
					<span className="text-danger">&nbsp;(Ưu tiên)</span>
				)}
			</div>
			<div className="flex m-0">
				<span className="text-uppercase fw-semibold">{data?.patientCode || ''}</span>
				<span className="px-1"> - </span>
				<span>{data?.visitObjectTypeName || ''}</span>
				<span className="px-1"> - </span>
				<span>{data?.gender || ''}</span>
				{data?.fulfillDeptName && <>
					<span className="px-1"> - </span>
					<span className='text-truncate'>{data?.fulfillDeptName || ''}</span>
				</>}
			</div>
		</div>
	);
};

export default PatientRowData;
